export const translations = {
  fr: {
    nav: { services: "Services", about: "À propos", stats: "Chiffres clés", contact: "Contact", cta: "Demander un audit" },
    hero: {
      eyebrow: "Depuis 2007 — Nyon, Suisse",
      line1: "La rigueur suisse",
      line2: "au service de",
      line3: "votre confiance.",
      sub: "Audit, révision, certification et conseil d'entreprise. Risc Goup Suisse SA accompagne les sociétés avec précision, indépendance et discrétion depuis plus de 17 ans.",
      cta1: "Planifier un entretien",
      cta2: "Découvrir nos services",
      badge: "ans d'expertise",
    },
    marquee: ["Audit financier", "Révision légale", "Certification", "Conseil d'entreprise", "Analyse des risques", "Conformité fédérale"],
    services: {
      eyebrow: "Domaines d'expertise",
      title: "Cinq piliers, une exigence absolue.",
      items: [
        { title: "Audit & Certification", desc: "Audit financier et certification des comptes selon les normes suisses et internationales, avec une méthodologie éprouvée depuis 2007." },
        { title: "Révision légale", desc: "Organe de révision agréé : contrôle restreint et ordinaire conformes au Code des obligations suisse." },
        { title: "Conseil d'entreprise", desc: "Accompagnement stratégique, transactions, restructurations et optimisation de la gouvernance d'entreprise." },
        { title: "Analyse des risques", desc: "Identification, cartographie et gestion des risques opérationnels, financiers et réglementaires." },
        { title: "Conformité & Regulatory", desc: "Mise en conformité avec les exigences fédérales suisses, veille réglementaire et reporting." },
      ],
    },
    about: {
      eyebrow: "Notre maison",
      title: "Un héritage d'exactitude, fondé en 2007.",
      p1: "Établie à Nyon, au cœur de l'arc lémanique, Risc Goup Suisse SA est une société d'audit et d'analyse des risques indépendante. Depuis près de deux décennies, nous servons PME, groupes et institutions avec une seule promesse : l'exactitude.",
      p2: "Notre pratique s'appuie sur le Code des obligations suisse et les standards de la profession, alliant tradition de précision helvétique et outils d'analyse contemporains.",
      card_title: "Registre officiel",
      founded: "Fondation",
      seat: "Siège",
      activity: "Activité",
      activity_val: "Sociétés d'audit et d'analyse des risques",
    },
    stats: {
      eyebrow: "Chiffres clés",
      title: "La mesure de notre engagement.",
      items: [
        { value: "17+", label: "Années d'expérience" },
        { value: "500+", label: "Mandats exécutés" },
        { value: "100%", label: "Conformité légale suisse" },
        { value: "2007", label: "Année de fondation" },
      ],
    },
    testimonials: {
      eyebrow: "Témoignages",
      title: "La confiance de nos clients, notre meilleure référence.",
      items: [
        {
          quote: "Une rigueur exemplaire et une disponibilité rare. Risc Goup Suisse accompagne notre révision depuis plus de dix ans avec une précision sans faille.",
          author: "Directeur financier",
          role: "Groupe industriel — Vaud",
        },
        {
          quote: "Leur analyse des risques a transformé notre gouvernance. Des recommandations claires, pragmatiques et toujours conformes au cadre fédéral.",
          author: "Administratrice",
          role: "Société fiduciaire — Genève",
        },
        {
          quote: "Un partenaire d'audit discret et exigeant, qui comprend les réalités des PME suisses. Nous recommandons sans réserve.",
          author: "CEO",
          role: "PME exportatrice — Nyon",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Parlons de votre prochain mandat.",
      sub: "Notre équipe vous répond sous 48 heures ouvrées, en toute confidentialité.",
      name: "Nom complet",
      email: "Adresse e-mail",
      phone: "Téléphone",
      company: "Société",
      service: "Service souhaité",
      service_placeholder: "Sélectionnez un service",
      message: "Votre message",
      submit: "Envoyer la demande",
      sending: "Envoi en cours…",
      success: "Votre demande a bien été enregistrée. Nous vous recontacterons rapidement.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      services_list: ["Audit & Certification", "Révision légale", "Conseil d'entreprise", "Analyse des risques", "Conformité & Regulatory"],
      address_title: "Notre adresse",
    },
    footer: {
      desc: "Société d'audit, révision, certification et conseil d'entreprise depuis 2007.",
      links: "Navigation",
      legal: "Mentions légales",
      rights: "Tous droits réservés.",
    },
  },
  en: {
    nav: { services: "Services", about: "About", stats: "Key figures", contact: "Contact", cta: "Request an audit" },
    hero: {
      eyebrow: "Since 2007 — Nyon, Switzerland",
      line1: "Swiss rigour",
      line2: "in the service of",
      line3: "your confidence.",
      sub: "Audit, statutory review, certification and corporate advisory. Risc Goup Suisse SA has served companies with precision, independence and discretion for over 17 years.",
      cta1: "Schedule a meeting",
      cta2: "Explore our services",
      badge: "years of expertise",
    },
    marquee: ["Financial audit", "Statutory review", "Certification", "Corporate advisory", "Risk analysis", "Federal compliance"],
    services: {
      eyebrow: "Areas of expertise",
      title: "Five pillars, one absolute standard.",
      items: [
        { title: "Audit & Certification", desc: "Financial audit and certification of accounts under Swiss and international standards, with a methodology proven since 2007." },
        { title: "Statutory Review", desc: "Licensed auditing body: limited and ordinary audits in accordance with the Swiss Code of Obligations." },
        { title: "Corporate Advisory", desc: "Strategic support, transactions, restructuring and corporate governance optimisation." },
        { title: "Risk Analysis", desc: "Identification, mapping and management of operational, financial and regulatory risks." },
        { title: "Compliance & Regulatory", desc: "Compliance with Swiss federal requirements, regulatory monitoring and reporting." },
      ],
    },
    about: {
      eyebrow: "Our firm",
      title: "A heritage of exactitude, founded in 2007.",
      p1: "Established in Nyon, at the heart of the Lake Geneva region, Risc Goup Suisse SA is an independent audit and risk analysis firm. For nearly two decades we have served SMEs, groups and institutions with a single promise: exactitude.",
      p2: "Our practice is grounded in the Swiss Code of Obligations and the profession's standards, combining the Swiss tradition of precision with contemporary analytical tools.",
      card_title: "Official registry",
      founded: "Founded",
      seat: "Registered office",
      activity: "Activity",
      activity_val: "Audit and risk analysis companies",
    },
    stats: {
      eyebrow: "Key figures",
      title: "The measure of our commitment.",
      items: [
        { value: "17+", label: "Years of experience" },
        { value: "500+", label: "Mandates completed" },
        { value: "100%", label: "Swiss legal compliance" },
        { value: "2007", label: "Year founded" },
      ],
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "Our clients' trust, our finest reference.",
      items: [
        {
          quote: "Exemplary rigour and rare availability. Risc Goup Suisse has handled our statutory review for over ten years with flawless precision.",
          author: "Chief Financial Officer",
          role: "Industrial group — Vaud",
        },
        {
          quote: "Their risk analysis transformed our governance. Clear, pragmatic recommendations, always compliant with the federal framework.",
          author: "Board Member",
          role: "Fiduciary company — Geneva",
        },
        {
          quote: "A discreet and demanding audit partner who understands the realities of Swiss SMEs. We recommend them without reservation.",
          author: "CEO",
          role: "Exporting SME — Nyon",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's discuss your next mandate.",
      sub: "Our team replies within 48 business hours, in full confidentiality.",
      name: "Full name",
      email: "Email address",
      phone: "Phone",
      company: "Company",
      service: "Service required",
      service_placeholder: "Select a service",
      message: "Your message",
      submit: "Send inquiry",
      sending: "Sending…",
      success: "Your inquiry has been recorded. We will get back to you shortly.",
      error: "Something went wrong. Please try again.",
      services_list: ["Audit & Certification", "Statutory Review", "Corporate Advisory", "Risk Analysis", "Compliance & Regulatory"],
      address_title: "Our address",
    },
    footer: {
      desc: "Audit, statutory review, certification and corporate advisory firm since 2007.",
      links: "Navigation",
      legal: "Legal information",
      rights: "All rights reserved.",
    },
  },
};
